import axios from "axios";

export const ScheduleListApi = async (token) => {
  try {
    const BASED_URL = process.env.REACT_APP_BASED_URL;
    const path = "/schedule/list?";

    const endpoint = `${BASED_URL}${path}token=${token}`;
    const response = await axios.get(endpoint);
    return response.data;
  } catch (error) {
    return error.response;
  }
};

export default ScheduleListApi;
